export const SIGUP_REQUEST="SIGNUP_REQUEST"
export const SIGUP_SUCCESSFUL="SIGNUP_SUCCESSFUL"
export const SIGUP_FAILURE="SIGNUP_FAILURE"

export const LOGIN_REQUEST="LOGIN_REQUEST"
export const LOGIN_SUCCESSFUL="LOGIN_SUCCESSFUL"
export const LOGIN_FAILURE="LOGIN_FAILURE"

export const LOGOUT_REQUEST="LOGOUT_REQUEST"
export const LOGOUT_SUCCESSFUL="LOGOUT_SUCCESSFUL"
export const LOGOUT_FAILURE="LOGOUT_FAILURE"

export const PROFILE_GET_REQUEST="PROFILE_GET_REQUEST"
export const PROFILE_GET_SUCCESSFUL="PROFILE_GET_SUCCESSFUL"
export const PROFILE_GET_FAILURE="PROFILE_GET_FAILURE"

export const PROFILE_UPDATE_REQUEST="PROFILE_UPDATE_REQUEST"
export const PROFILE_UPDATE_SUCCESSFULL="PROFILE_UPDATE_SUCCESSFULL"
export const PROFILE_UPDATE_FAILURE="PROFILE_UPDATE_FAILURE"

